<template>
   <ul class="tab_container">
       <li v-for="(item,index) in items" :key="index"  :class="['tab_item',index + 1 == activeIndex ? 'active' : '']" v-on:click="chooseTab(index+1)" >
           <p class="main" v-if="!!item.main">{{item.main}}</p>
           <p class="sub" v-if="!!item.sub">{{item.sub}}</p>
       </li>
   </ul>
</template>
<script>
export default {
  name: 'TabMethod',
  componentName: 'TabMethod',
  data () {
    return {
      activeIndex: this.defaultActiveIndex
    }
  },
  methods: {
    chooseTab: function (key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key
        this.$emit('listenChooseEvent', key)
      }
    }
  },
  props: {
    items: Array,
    defaultActiveIndex: Number
  }
}
</script>

<style scoped lang="stylus">
    .tab_container{
        display: -webkit-box
        display: -moz--moz-box
        display: -ms-flexbox
        display: -webkit-flex
        display: flex
        cursor: pointer
        .tab_item{
            width: 270px
            border: 1px solid #CCC
            padding: 9px
            text-align: center
            .main{
                font-size: 14px
                color: #333
                line-height: 20px
            }
            .sub{
                font-size: 12px
                color: #999
                line-height: 17px
            }
        }

        li.active{
            border: 1px solid #3468FF
            background none
            .main{
                color: #3468FF
            }
        }
    }
</style>
